import { ampli } from 'lib-shared-tracking';

import { PartnerTrackingEventsProps } from '../partners.types';

export const rechargePartnerTrackingEvents = ({
  partnerEvents,
}: PartnerTrackingEventsProps): void => {
  partnerEvents.on('recharge:profile:received', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetProfileReceived(payload),
  );

  partnerEvents.on('recharge:external:customer:overview:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetCustomerOverviewOpened(payload),
  );

  partnerEvents.on('recharge:external:order:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetOrderOpened(payload),
  );

  partnerEvents.on('recharge:external:orders:list:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetOrdersListOpened(payload),
  );

  partnerEvents.on('recharge:external:subscription:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetSubscriptionOpened(payload),
  );

  partnerEvents.on('recharge:external:subscriptions:list:opened', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetSubscriptionsListOpened(payload),
  );

  partnerEvents.on('recharge:subscription:cancelled', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetSubscriptionCancelled(payload),
  );

  partnerEvents.on('recharge:subscription:reactivated', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetSubscriptionReactivated(payload),
  );

  partnerEvents.on('recharge:subscription:order:skipped', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetSubscriptionSkipped(payload),
  );

  partnerEvents.on('recharge:subscription:product:swapped', (payload) =>
    ampli.partnerIntegrationsRechargeWidgetSubscriptionSwapped(payload),
  );
};
